import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { MdKeyboardArrowDown } from 'react-icons/md';
import './FAQComponent.css'


export default function FAQComponent() {

  const faqList = [
    {
      question: "Who can participate in the challenge?",
      answer: "The hackathon is open to data enthusiasts of all skill levels. Whether you're a seasoned analyst or a beginner, we welcome your participation."
    },
    {
      question: "How do I register for the hackathon?",
      answer: "To register, follow KSR Datavizon on LinkedIn and keep an eye out for our registration announcement. Detailed registration instructions will be provided there."
    },
    {
      question: "Is team participation allowed?",
      answer: "No, team participation is not allowed. Each participant must work individually to complete and submit their entry."
    },
    {
      question: "Is the video presentation mandatory?",
      answer: "No, the video presentation is optional. However, participants who submit a video presentation will gain additional points."
    },
    {
      question: "How can I contact the organizers if I have more questions?",
      answer: (
        <>
          For any additional inquiries, please reach out to us via email at <a href="mailto:support@datavizon.com" style={{ textDecoration: "none", color: "var(--mainColor)" }}>support@datavizon.com</a> or <a href="mailto:hackathons@datavizon.com" style={{ textDecoration: "none", color: "var(--mainColor)" }}>hackathons@datavizon.com</a>.
        </>
      )
    }
  ];

  return (
    <div>
      <p className='DatasetHeading'>FAQs</p>
      <div className='faqSection'>
        {
          faqList.map((e, id) => {
            return (
              <Accordion className='eachFaq' key={id} sx={{
                margin: '0px !important',
                padding: '0px',
                '&:before': {
                  display: 'none',
                },
              }}>

                <AccordionSummary
                  expandIcon={<MdKeyboardArrowDown />} aria-controls="panel1-content" id="panel1-header" key={id}
                  className='faqQuestion'
                >
                  <span className='border'></span> {e.question}
                </AccordionSummary>

                <AccordionDetails className='faqAnswer'>{e.answer}</AccordionDetails>
              </Accordion>
            )
          })
        }
      </div>


    </div>
  );
}
